import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TurnedIn from 'material-ui/svg-icons/action/turned-in';
import TurnedInNot from 'material-ui/svg-icons/action/turned-in-not';

import { Create } from 'components/detail';
import { SimpleForm } from 'components/form';
import { TextInput, CheckboxGroupInput, FileInput } from 'components/input';
import { ImageField } from 'components/field';

import { crudGetMeta as crudGetMetaAction } from 'actions/dataActions';

import * as urls from './urls';

const mapStateToProps = (state, props) => ({
  meta: state.admin[props.resource].meta,
});


class ShopTemplateCreateBase extends Component {

  static propTypes = {
    crudGetMeta: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { resource } = this.props;
    this.props.crudGetMeta(resource, urls.shopTemplateCreateBackendPath);
  }

  render() {
    const categoryChoices = this.props.meta['category_choices'];
    return (
      <Create createBackendPath={urls.shopTemplateCreateBackendPath} {...this.props}>
        <SimpleForm>
          <TextInput source="en" label="Name" isRequired={true}/>
          <TextInput source="translation" label="Name(Local)" isRequired={true}/>
          <CheckboxGroupInput
            label="Categories"
            source="category_ids"
            choices={categoryChoices}
            options={{ checkedIcon: <TurnedIn />, uncheckedIcon: <TurnedInNot /> }}
          />
        </SimpleForm>
      </Create>
    )
  }
}


export const ShopTemplateCreate = connect(
  mapStateToProps,
  { crudGetMeta: crudGetMetaAction },
)(ShopTemplateCreateBase);


class ShopCategoryCreateBase extends Component {

  static propTypes = {
    crudGetMeta: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { resource } = this.props;
    this.props.crudGetMeta(resource, urls.shopCategoryCreateBackendPath);
  }

  render() {
    const itemChoices = this.props.meta['item_choices'];
    return (
      <Create createBackendPath={urls.shopCategoryCreateBackendPath} {...this.props}>
        <SimpleForm>
          <TextInput source="en" label="Name" isRequired={true}/>
          <TextInput source="translation" label="Name(Local)" isRequired={true}/>
          <CheckboxGroupInput
            label="Items"
            source="item_ids"
            choices={itemChoices}
            options={{ checkedIcon: <TurnedIn />, uncheckedIcon: <TurnedInNot /> }}
          />
        </SimpleForm>
      </Create>
    );
  }

}
export const ShopCategoryCreate = connect(
  mapStateToProps,
  { crudGetMeta: crudGetMetaAction },
)(ShopCategoryCreateBase);


export class ShopItemCreate extends Component {
  handleSubmit = (props, basePath) => (record) => {
    const formDataRecord = new FormData();
    formDataRecord.append('en', record['en']);
    formDataRecord.append('translation', record['translation']);
    if (record['image'])
      formDataRecord.append('image', record['image']);

    props.crudCreate(props.resource, formDataRecord, props.createBackendPath, basePath);
  };

  render() {
    return (
      <Create
        createBackendPath={urls.shopItemCreateBackendPath}
        handleSubmit={this.handleSubmit}
        {...this.props}
      >
        <SimpleForm>
          <TextInput source="en" label="Name" isRequired={true}/>
          <TextInput source="translation" label="Name(Local)" isRequired={true}/>
          <FileInput source="image" label="Image" placeholder={<p>Select or drop your image here</p>}>
            <ImageField source="src" title="title"/>
          </FileInput>
        </SimpleForm>
      </Create>
    );
  }
}


// WEBPACK FOOTER //
// ./src/routes/shop/ShopTemplateCreate.js